module.exports = __webpack_public_path__ + "static/media/edit_icon.e5b2c6f2.svg";